/* eslint-disable import/prefer-default-export */
import { useContext, useEffect, useState } from "react"

import { WalletContext } from "#/shared/context"
import { isSameAddress } from "#/shared/utils"

import { EthersV5Signer, EthersV6Signer } from "./wagmi"

const validateSigners = async (
  address: string | undefined,
  signerEthersV5: EthersV5Signer | undefined,
  signerEthersV6: EthersV6Signer | undefined,
  mezoSigner: EthersV6Signer | undefined,
) => {
  if (!address || !signerEthersV5 || !signerEthersV6 || !mezoSigner) {
    // This is ok - useEffect is running a few times before we have all the data
    return false
  }

  if (
    !isSameAddress(await signerEthersV5.getAddress(), address) ||
    !isSameAddress(await signerEthersV6.getAddress(), address) ||
    !isSameAddress(await mezoSigner.getAddress(), address)
  ) {
    return false
  }

  return true
}

export const useValidateSigners = () => {
  const [validSigners, setValidSigners] = useState(false)

  const { address, signerEthersV5, signerEthersV6, signerMezo } =
    useContext(WalletContext)

  useEffect(() => {
    const validateSignersCallback = async () => {
      const hasValidSigners = await validateSigners(
        address,
        signerEthersV5,
        signerEthersV6,
        signerMezo,
      )

      setValidSigners(hasValidSigners)
    }

    validateSignersCallback()
  }, [address, signerEthersV5, signerEthersV6, signerMezo])

  return { hasValidSigners: validSigners }
}
